module.exports = __webpack_public_path__ + "static/img/img3.cbe2aeea.png";